import commonApi from '@/api/_common.js'

const formatDate = (date) => {
    if (!date || date.length !== 10 || !date.includes('-')) return date
    return date.replace(/-/g, '')
}

const makeStatsCall = (endpoint, param, scb, fcb, va) => {
    const searchStart = formatDate(param?.search_start ?? '')
    const searchEnd = formatDate(param?.search_end ?? '')

    const reqURL = `${endpoint}?search_start_date=${searchStart}&search_end_date=${searchEnd}`

    commonApi.GET(reqURL,
        (data) => scb?.(data.stat_list, data.total_count, va),
        (err) => {
            console.log(`api.stats.${endpoint.split('/').pop()} : FAIL :`, err)
            fcb?.(err, va)
        },
        va
    )
}

export default {
    getMenuList: (param, scb, fcb, va) => makeStatsCall('/stat/menu_list', param, scb, fcb, va),
    getUserList: (param, scb, fcb, va) => makeStatsCall('/stat/user_list', param, scb, fcb, va),
    getSvcCallList: (param, scb, fcb, va) => makeStatsCall('/stat/svc_call_list', param, scb, fcb, va),
}